export const fragmentShader = `
  uniform vec4 planes[6];
  uniform int do_plane_clipping;

  varying vec4 col;
  varying vec3 fpos;

  void main() {
    if (do_plane_clipping > 0) {
      for(int i = 0 ; i < 6 ; i ++) {
        if (dot(planes[i], vec4(fpos, 1.0)) < 0.0)
          discard;
      }
    }

    gl_FragColor = col;
  }
`;